import MetricBar from './MetricBar';

export default MetricBar;
